import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportMapaConcretagemUseCase } from "../../../presentation/useCases/read/get_report_mapa_concretagem_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportMapaConcretagemUseCase
 */

export class GetReportMapaConcretagemUseCase implements IGetReportMapaConcretagemUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportMapaConcretagem(
    requiredMimeType: ReportMimeType | null,
    idObra: number,
    dataInicio: Date | null,
    dataFim: Date | null,
    fornecedores: number[] | null,
    localLancamento: string | null,
    resistencia: string | null,
    nroNotaFiscal: string | null,
    statusRompimento: number,
    enviadoLaboratorio: number,
    colunas: {
      dataConcretagem: boolean,
      tipoDoConcretoSolicitado: boolean,
      slumpSolicit: boolean,
      ensaioDoConcreto: boolean,
      resistMpa: boolean,
      fornecedor: boolean,
      nroDoCarro: boolean,
      nroNotaFiscal: boolean,
      saidaUsina: boolean,
      entObra: boolean,
      inicioLanc: boolean,
      finalLanc: boolean,
      qtdeM3: boolean,
      slump: boolean,
      localDeLancamento: boolean,
      dataDeEnvioDaObra: boolean,
      laboratorio: boolean,
      nroCorpoDeProva: boolean,
      nroLote: boolean,
      instrucaoDeRompimento: boolean,
      enviadoParaOLaboratorio: boolean,
      dataDeEnvioParaOLaboratorio: boolean,
      dozeHoras: boolean,
      dataDozeHoras: boolean,
      quatroDias: boolean,
      dataQuatroDias: boolean,
      seteDias: boolean,
      dataSeteDias: boolean,
      quatorzeDias: boolean,
      dataQuatorzeDias: boolean,
      vinteUmDias: boolean,
      dataVinteUmDias: boolean,
      vinteOitoDias: boolean,
      dataVinteOitoDias: boolean,
      cinquentaSeisDias: boolean,
      dataCinquentaSeisDias: boolean,
      sessentaTresDias: boolean,
      dataSessentaTresDias: boolean,
      outrasIdades1: boolean,
      dataOutrasIdades1: boolean,
      outrasIdades2: boolean,
      dataOutrasIdades2: boolean,
      outrasIdades3: boolean,
      dataOutrasIdades3: boolean,
      aprovado: boolean,
      responsavelPelaAprovacao: boolean,
      dataDaAprovacao: boolean,
      observacao: boolean,
    },
  ): Promise<ReportData> {
    const response = await this.repository.getReportMapaConcretagem(
      requiredMimeType,
      idObra,
      dataInicio,
      dataFim,
      fornecedores,
      localLancamento,
      resistencia,
      nroNotaFiscal,
      statusRompimento,
      enviadoLaboratorio,
      colunas,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `mapa_concretagem_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
